module.exports = __webpack_public_path__ + "img/gearSun.fb901ad4.png";